<template>
    <div>
        <v-subheader>Admin</v-subheader>
        <v-list-item link to="/admin/api">
          <v-list-item-icon>
            <v-icon>mdi-api</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Manage API</v-list-item-title>
        </v-list-item>
    </div>
</template>

<script>

export default {
  name: 'MitMenuAdmin',
  components: {
  },
  props: {
    userModel: Object
  }
}
</script>

<style lang="scss" scoped>
</style>
